import { css } from 'styled-components';
import {
  getSpacing, SpacingName, getTypography, TypographyName, ThemedFunctor,
} from '@doveit/lego';

export const base = css`
  width: 100%;
`;

export const item: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.BODY)};
  ${getSpacing.padding(theme, [SpacingName.SMALL, 0])}

  border-bottom: 1px solid ${theme.palettes.neutrals.light};
  display: block;
`;
